<div class="grid-y footer">
  <div class="cell small-12 medium-12 divider-cell">
    <hr class="divider">
  </div>
  <div class="cell">
    <div class="grid-x align-center">
      <div class="cell small-12 medium-shrink">
        <span id="copyright-aq">{{"footer.copyright-aq" | translate:{year: currentYear} }}</span>
      </div>
      <div *ngIf="showApplicationSupport" class="cell small-2 medium-shrink hide-for-small-only footer-divider"> | </div>
      <div *ngIf="showApplicationSupport" class="cell small-12 medium-shrink">
        <a id="application-support" class="link" (click)="navigateToUrl($event)">{{"footer.application-support" | translate}}</a>
      </div>
      <div class="cell small-2 medium-shrink hide-for-small-only footer-divider"> | </div>
      <div class="cell small-12 medium-shrink">
        <a id="privacy-policy" class="link" (click)="navigateToUrl($event)">{{"footer.privacy-policy" | translate}}</a>
      </div>
      <div class="cell small-2 medium-shrink hide-for-small-only footer-divider"> | </div>
      <div class="cell small-12 medium-shrink">
        <a id="questions-email" class="link" href="mailto:questions@aquent.com">{{"footer.questions-email" | translate}}</a>
      </div>
    </div>
  </div>
</div>
